<template>
  <Row class-name="bodys" :style="{ 'min-height': `${$store.state.init.offsetHeight - 251}px` }">
    <Col span="24">
      <BreadcrumbWrap class="breadcrumb" />
    </Col>
    <Col span="24">
      <Row>
        <Col
          :sm="12"
          :xs="24"
        >
          <div class="spin" v-if="loading">
            <Spin fix />
          </div>
          <Tree
            ref="tree"
            class="tree"
            v-else
            :data="data"
            @on-select-change="handleSelectChange"
          />
        </Col>
        <Col
          :sm="12"
          :xs="24"
        >
          <MyDetails v-if="sign == 'eng'" />
          <Table
            v-else
            class="table"
            :columns="filesColumns"
            :data="filesData"
            border
            stripe
          ></Table>
        </Col>
      </Row>
    </Col>
  </Row>
</template>

<script>
import { GetEngineerAllInfo } from '@api'
import MyDetails from './details'
import BreadcrumbWrap from '@components/breadcrumb-wrap'
export default {
  name: 'information',
  components: { MyDetails, BreadcrumbWrap },
  data () {
    return {
      data: [],
      sign: 'eng',
      filesColumns: [],
      filesData: [],
      loading: false
    }
  },
  computed: {
    config () {
      return window.config
    }
  },
  mounted () {
    this.buildTreeData()
    this.buildFilesColumns()
  },
  methods: {
    async buildTreeData () {
      this.loading = true
      try {
        const query = {
          ENG_SID: this.$route.query.id,
          SID: this.$route.query.file
        }
        const { data } = await GetEngineerAllInfo(query)
        this.data = [data].map(m => ({
          title: m.ENG_NAME,
          expand: true,
          selected: true,
          sign: 'eng',
          children: m.archs.map(r => ({
            title: r.ARCH_TITLE,
            files: r.files,
            sign: 'archs'
          }))
        }))
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    buildFilesColumns () {
      this.filesColumns = [
        {
          type: 'index',
          width: 60,
          align: 'center'
        }, {
          title: '文件题名',
          key: 'FILE_Title'
        }
      ]
    },
    handleSelectChange (list, { sign, files }) {
      this.sign = sign
      sign === 'archs' && (this.filesData = files)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@theme/globle.scss';
.bodys {
  background: #fff;
  padding: 16px;
  border-top: 2px solid $default;
}
.tree {
  margin-right: 16px;
}
.breadcrumb {
  margin-bottom: 4px;
}
.table {
  margin-top: 8px;
}
.spin {
  height: 500px;
}
</style>
